import logo from '../../FamilyCouncilLogo.jpg';

export const LandingSection = () => {
  return (
    <div className="dark:bg-slate-900 bg-slate-50 relative overflow-hidden min-h-[80vh] flex items-center">
      <div id="home" className="w-full flex relative items-center overflow-hidden">
        <div className="container mx-auto px-6 flex flex-col lg:flex-row items-center relative py-8 lg:py-16">
          <div className="sm:w-2/3 lg:w-3/5 flex flex-col relative">
            <h1 className="text-4xl sm:text-7xl font-extrabold tracking-tight flex flex-col leading-tight dark:text-white text-slate-900 mb-4">
              A place to <br/>
              <span className="text-blue-600 dark:text-blue-400">stay connected.</span>
            </h1>
            <p className="text-base sm:text-xl text-slate-600 dark:text-slate-300 max-w-lg mt-4 leading-relaxed">
              A website that connects our family beyond the council meetings
            </p>
          </div>
          <div className="mt-8 lg:mt-0 flex-1 flex flex-col items-center">
            <figure>
              <img
                className="w-48 sm:w-64 block mx-auto rounded-3xl shadow-2xl border-4 border-white dark:border-slate-800"
                src={logo}
                alt="Logo"
              />
              <figcaption
                className="mt-8 text-center"
              >
                <a href={logo} download className="inline-flex items-center justify-center px-8 py-3 text-base font-medium text-white bg-blue-600 hover:bg-blue-700 rounded-full shadow-md transition-all hover:shadow-lg hover:-translate-y-0.5">
                  Download Logo
                  <svg className="w-5 h-5 ml-2" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4" /></svg>
                </a>
              </figcaption>
            </figure>
          </div>
        </div>
      </div>
    </div>
  );
};
